import script from "./MemberView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberView.vue?vue&type=script&lang=ts&setup=true"

import "./MemberView.vue?vue&type=style&index=0&id=3fb4fd0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb4fd0f"]])

export default __exports__